export default () => {
    return {
        tag: 'select',
        defaultItem: {
            tag: 'option'
        },
        items: [
            { text: 'Alice' },
            { text: 'Bob' },
            { text: 'Charlie' },
        ]
    };
};
